const applyConfig = (config) => {
  config.experimental.addBlockButton.enabled = true;
  config.settings.navDepth = 3;
  config.settings.pluggableStyles = [
    ...(config.settings.pluggableStyles || []),
    {
      id: 'primaryBox',
      title: 'Primary',
      cssClass: 'primary-box',
    },
    {
      id: 'secondaryBox',
      title: 'Secondary',
      cssClass: 'secondary-box',
    },
    {
      id: 'tertiaryBox',
      title: 'Tertiary',
      cssClass: 'tertiary-box',
    },
    {
      id: 'grayBox',
      title: 'Gray',
      cssClass: 'gray-box',
    },
    {
      id: 'blueBox',
      title: 'Blue',
      cssClass: 'blue-box',
    },
    {
      id: 'purpleBox',
      title: 'Purple',
      cssClass: 'purple-box',
    },
  ];
  config.settings.available_colors = [
    '#d92518',
    '#2e3233',
    '#FFB907',
    '#e1e1e1',
    '#eeeeee',
    '#ffffff',
    '#000000',
    '#1D3A83',
    '#FFB81C',
    '#C4D600',
    '#FFE293',
    '#59CBE8',
    '#FE8807',
    '#8363AA',
    '#BCBEC0',
  ];
  config.settings.image_crop_aspect_ratios = [
    {
      label: '16:9',
      ratio: 16 / 9,
    },
    {
      label: '1:1',
      ratio: 1,
    },
    {
      label: '2:3',
      ratio: 2 / 3,
    },
  ];
  // Blacklist specific listing variations
  const blacklistedVariations = ['summary', 'cardsCarousel', 'cardsGallery'];
  config.blocks.blocksConfig.listing.variations = config.blocks.blocksConfig.listing.variations.filter(
    (variation) => !blacklistedVariations.includes(variation.id),
  );
  config.settings.siteTitleFormat = {
    includeSiteTitle: true,
    titleAndSiteTitleSeparator: '-',
  };
  // Add this line to force GET requests for querystring search
  config.settings.querystringSearchGet = true;
  return config;
};

export default applyConfig;
